import { messages } from '../../messages';
export var toMessage = function toMessage(defaultMessage, key) {
  try {
    if (key !== undefined && key in messages) {
      return messages[key];
    }
    return defaultMessage;
  } catch (_unused) {
    return defaultMessage;
  }
};